import { gmLazyLoad } from '../util/lazyLoad'
import * as mapPin from '../../images/icons/maps/icon-map-marker.png';

export default () => {

  const $mapEl = $('.js-restaurantContactMap__map')

  if ( !$mapEl.length ) return
  let lat = $mapEl.attr('data-lat')
  let lng = $mapEl.attr('data-lng')

  if ( !lat || !lng ) {
    return
  }

  lat = parseFloat(lat)
  lng = parseFloat(lng)

   /* eslint-disable */  
  const renderMap = () => {
    const map = new google.maps.Map(
    $mapEl[0], {
        zoom: 16,
        center: {lat, lng},
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
    });

    const pin_coords = new google.maps.LatLng(lat, lng)
    map.setCenter( pin_coords );

    new google.maps.Marker({
        map: map,
        position: pin_coords,
        icon: {
            url: mapPin,
            scaledSize: new google.maps.Size(25, 38),
        },
    });
  }
  /* eslint-enable */

  gmLazyLoad('.js-restaurantContactMap__map')
    .then( () => renderMap() )
}